export enum EnUTMFields {
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
}

export enum EnUTMMediumStatics {
  HOME = 'home',
  PRODUCTS = 'products',
}
